export default __webpack_public_path__ + "static/media/JP5-1.9e9f0a48.jpg";